import axios from '../../axios'

/*
 * 医生商品管理模块
 */

// 新增保存
export const commodityCreate = (data) => {
  return axios({
    url: '/berry-pub/commodity/commodityCreate',
    method: 'post',
    data
  })
}

// 上传图片
export const uploadImages = (data) => {
  return axios({
    url: '/berry-pub/commodity/uploadImages',
    method: 'post',
    data
  })
}
// 编辑保存
export const updateByPrimaryKeySelective = (data) => {
  return axios({
    url: '/berry-pub/doctor/commodity',
    method: 'post',
    data
  })
}

// 编辑保存
export const updateByPrimaryKey = (data) => {
  return axios({
    url: '/berry-pub/commodity/update_by_primary_key',
    method: 'post',
    data
  })
}


// 删除
export const deleteByPrimaryKey = (data) => {
  return axios({
    url: '/berry-pub/commodity/delete_by_primary_key',
    method: 'post',
    data
  })
}

// 删除
export const batchDelete = (data) => {
  return axios({
    url: '/berry-pub/commodity/delete',
    method: 'post',
    data
  })
}



// 主键查询
export const selectByPrimaryKey = (id) => {
  return axios({
    url: '/berry-pub/commodity/select_by_primary_key',
    method: 'get',
    params:{id:id}
  })
}
// 主键扩展查询
export const selectWrapperByPrimaryKey = (id) => {
  return axios({
    url: '/berry-pub/commodity/select_wrapper_by_primary_key',
    method: 'get',
    params:{id:id}
  })
}

// 分页查询
export const selectListPage = (data) => {
  return axios({
    url: '/berry-pub/commodity/select_list_page',
    method: 'post',
    data
  })
}

// 分页列表查询
export const selectListWrapperPage = (data) => {
  return axios({
    url: '/berry-pub/commodity/select_list_wrapper_page',
    method: 'post',
    data
  })
}

// 列表查询
export const selectList = (data) => {
  return axios({
    url: '/berry-pub/commodity/select_list',
    method: 'post',
    data
  })
}

// 列表扩展查询
export const selectListWrapper = (data) => {
  return axios({
    url: '/berry-pub/commodity/select_list_wrapper',
    method: 'post',
    data
  })
}


// 查询商品关联树
export const findCommoditytTree = () => {
  return axios({
    url: '/berry-pub/commodity/findTree',
    method: 'get'
  })
}




// WEBPACK FOOTER //
// ./src/http/modules/pub/commodity.js